import * as React from "react";
import styled from "styled-components";

const SVG = styled.svg`
  overflow: visible;
`;

const TopPath = styled.path`
  transform-origin: center;
  transition: all 0.3s ease;

  ${SVG}:hover & {
    transform: rotate(-12deg) translateY(-8px);
  }
`;

const BottomPath = styled.path`
  transform-origin: center;
  transition: all 0.3s ease;

  ${SVG}:hover & {
    transform: rotate(12deg) translateY(8px);
  }
`;

export const SvgChevronLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <SVG viewBox="0 0 85 141" fill="none" {...props}>
    <TopPath
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.0227 94.3201C53.4334 102.973 81.2667 118.267 82.8374 120.173C83.7547 121.28 84.3001 123.707 84.5507 126.107C84.8694 129.147 84.5868 132.827 82.9814 136.534C81.5708 139.787 79.2241 141.2 77.3201 140.094C59.0721 129.494 12.9294 100.333 7.61205 97.9468C6.01872 97.2401 4.95073 95.0668 5.88806 90.9201C6.65073 87.5468 8.13473 83.9068 9.58673 81.1468C10.3867 79.6268 11.9094 79.0134 12.8841 79.0534C15.0001 79.1601 16.9734 79.9334 19.0041 80.4401C19.0814 80.2001 34.6627 88.7468 42.0227 94.3201Z"
      fill="currentColor"
    />
    <BottomPath
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.9265 26.9068C39.5679 20.1735 65.1305 1.33358 67.5239 0.706917C68.9172 0.333585 71.3452 0.866914 73.6239 1.64025C76.5225 2.62691 79.7386 4.42691 82.4265 7.44023C84.7906 10.0802 85.0932 12.8136 83.2892 14.0669C66.0052 26.1869 20.1759 55.8401 15.7852 59.6668C14.4785 60.8134 12.0505 60.8668 8.68121 58.2801C5.93988 56.1735 3.26521 53.3068 1.35987 50.8268C0.317206 49.4535 0.407881 47.8268 0.851881 46.9468C1.82922 45.0802 3.36255 43.6135 4.66922 41.9735C4.49322 41.8135 18.7772 31.2535 26.9265 26.9068Z"
      fill="currentColor"
    />
  </SVG>
);
